"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/require-default-props */
var react_1 = __importDefault(require("react"));
var react_2 = require("@fluentui/react");
var HelperButton_1 = require("./HelperButton");
require("./CustomLabel.scss");
require("./Forms.scss");
var CustomLabel = function (props) {
    var toolTip = props.toolTip, toolTipLink = props.toolTipLink, toolTipLinkOnClick = props.toolTipLinkOnClick;
    return (react_1.default.createElement("div", { className: "eta-horizontalFlexDiv customLabelAlignCenter" },
        react_1.default.createElement(react_2.Label, __assign({}, props)),
        react_1.default.createElement("div", { className: "eta-space" }),
        toolTip && react_1.default.createElement(HelperButton_1.HelperButton, null, toolTip),
        toolTipLink && (react_1.default.createElement(react_2.ActionButton, { iconProps: { iconName: 'info' }, onClick: function () {
                if (toolTipLinkOnClick) {
                    toolTipLinkOnClick();
                }
            } }, toolTipLink))));
};
exports.Label = CustomLabel;
//# sourceMappingURL=CustomLabel.js.map